import { perspectives as perspectivesData } from "@/data/perspectives";
import { shuffle } from "@/utils/shuffle";
import { hasFocusVisible } from "@/utils/has-focus";
import type { PaddingSize } from "../content-section/index.marko";
import s from "./style.module.css";
export interface Input extends Marko.HTML.Section {
    paddingBlock?: (PaddingSize | null)[];
    paddingInline?: boolean;
}
static const colors = [
    "violet",
    "teal",
    "kiwi",
    "lilac",
    "blue",
    "jade",
    "pink",
];
<const/perspectives=shuffle(perspectivesData)>
// This is only relevant for keyboard users.
// All other interactions use :hover.
<let/activeIndex=-1>

<content-section
    class=s.container
    paddingBlock=input.paddingBlock
    paddingInline=input.paddingInline>
    <evo-carousel/carouselRef class=s.carousel>
        <@items>
            <for|perspective, i| of=perspectives>
                <perspective-card-2
                    ...perspective
                    theme=colors[i % colors.length]
                    active=activeIndex === i
                    onClick(e) {
                        const { target } = e;
                        if (!(target instanceof HTMLButtonElement)) return;

                        const canHover =
                            window.matchMedia("(hover: hover)").matches;
                        const isFocused = hasFocusVisible(target);

                        if (isFocused && canHover) {
                            if (activeIndex !== i) activeIndex = i;
                            else activeIndex = -1;
                        }
                    }/>
            </for>
        </@items>
    </evo-carousel>
</content-section>

<script>
    function handleOutsideClick(event: Event) {
        if (!(event.target instanceof Element)) return;
        if (!carouselRef().contains(event.target)) {
            activeIndex = -1;
        }
    }
    document.addEventListener("click", handleOutsideClick, {
        signal: $signal,
    });
</script>
